import { Drawer, DrawerContent, DrawerOverlay, FormControl, FormLabel, FormHelperText, Select, Heading, HStack } from "@chakra-ui/react"
import { Button, Input, Stack, IconButton, useColorModeValue, ChakraProvider, Text, SimpleGrid, MenuButton } from '@chakra-ui/react'
import { forwardRef } from "react"
import * as _ from 'lodash-es'

export const PtDrawer = (props) => <Drawer {...props} />

export const PtDrawerContent = (props) => <DrawerContent {...props} />

export const PtDrawerOverlay = (props) => <DrawerOverlay {...props} />

export const PtChakraProv = ({theme, children}) => {
  return <ChakraProvider {...{theme}}>
    {children}
  </ChakraProvider>
}

export const usePtColorModeValue = (light, dark) => useColorModeValue(light, dark)

export const Form1Control = (props) => <FormControl {...props} />
export const HorControl = (props) => <Form1Control {...{as: HStack, ...props}} />

export const Form1Label = (props) => <FormLabel {...props} />
export const Form1HelperText = (props) => <FormHelperText {...props} />

export const PtSel = (props) => <Select {...props} />

export const PtAck = forwardRef((/** @type {any} */ props, ref) => {
  return <Stack {...{ref, ...props}} />
})

export const PtBtn = forwardRef((/** @type {any} */ props, ref) => {
  if (_.isBoolean(props.loading)) {
    props = {...props, isLoading: props.loading}
    delete props.loading
  }
  if (_.isBoolean(props.disabled)) {
    props = {...props, isDisabled: props.disabled ? '' : undefined}
  }
  return <Button {...{ref, ...props}} />
})

export const Icon1Btn = forwardRef((/** @type {any} */ props, ref) => {
  return <IconButton {...{...props, ref}} />
})

export const PtInput = forwardRef((/** @type {any} */ props, ref) => {
  return <Input {...{ref, ...props}} />
})

export const Simple1Grid = (props) => <SimpleGrid {...props} />

export const Ptext = forwardRef((/** @type {any} */ props, ref) => {
  return <Text {...{...props, ref}} />
})

export const MenuPtBtn = (props) => <MenuButton {...{as: Button, ...props}} />

export const CentHeading = (props) => <Heading {...{textAlign: 'center', ...props}} />
